import React from 'react';
import { ThemedText } from '../../../components';

export default function LinkValue({ value, formatted, field, emptyValue = '—', theme }) {
  if (formatted == null) {
    return <ThemedText style={{ color: theme?.colors?.muted }}>{emptyValue}</ThemedText>;
  }

  const fieldType = field?.type || '';
  let href = formatted;
  if (fieldType === 'email' || fieldType === 'Email') {
    href = `mailto:${formatted}`;
  } else if (fieldType === 'phone' || fieldType === 'Phone') {
    href = `tel:${formatted}`;
  } else if (!/^https?:\/\//.test(formatted)) {
    href = `https://${formatted}`;
  }

  return (
    <a href={href} target="_blank" rel="noopener noreferrer" style={{ color: theme?.colors?.primary }}>
      {formatted}
    </a>
  );
}
